(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'GptPrompt',
	};

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load()
	{
		// handle gpt prompt instructions toggle
		$('.custom-toggle-icon').on('click', function toggleInstructions(e) {
			var toggle = $(this);

			e.preventDefault();

			if (toggle.hasClass('expanded')) {
				// it's expanded, so collapse it
				$('.gpt-prompts-shown').addClass('hidden d-none');
				$('.gpt-prompts-hidden').removeClass('hidden d-none');

				// update icon
				toggle.removeClass('expanded');
				toggle.removeClass('fa-minus-square');
				toggle.addClass('collapsed');
				toggle.addClass('fa-plus-square');
			} else {
				// it's collapsed, so expand it
				$('.gpt-prompts-hidden').addClass('hidden d-none');
				$('.gpt-prompts-shown').removeClass('hidden d-none');

				// update icon
				toggle.removeClass('collapsed');
				toggle.removeClass('fa-plus-square');
				toggle.addClass('expanded');
				toggle.addClass('fa-minus-square');
			}
		});

		$('.generate').on('click', function _getResponse(e) {
			var prompt         = $('#gptprompt-gpt_prompt').val(),
				prompt_trimmed = prompt.trim(),
				responses      = '';

			e.preventDefault();

			if (prompt_trimmed.length === 0) {
				Adzuki.StatusMessage('Error', 'Please provide a full prompt in order to proceed.');
			} else {
				$('#gptprompt-loader-1').css('visibility', 'visible');
				$('#gptprompt-loader-2').removeClass('hidden d-none');
				$('#gptprompt-gpt_response').addClass('hidden d-none');

				// replace line breaks with spaces in prompt_trimmed
				prompt_trimmed = prompt_trimmed.replace(/(\r\n|\n|\r)/gm, " ");

				Adzuki.Ajax.post('/Ai/processPrompt/', {prompt: prompt_trimmed}).then(function success(content) {
					$.each(content.messages, function onEachMessage(i, message) {
						responses += message + "\r\n";
					});

					$('#gptprompt-gpt_response').val(responses);
					$('#gptprompt-loader-1').css('visibility', 'hidden');
					$('#gptprompt-loader-2').addClass('hidden d-none');
					$('#gptprompt-gpt_response').removeClass('hidden d-none');
					$('.refine-prompt-container').removeClass('hidden d-none');

					// reload history tab
					Adzuki.Ajax.get('/Ai/gptHistory')
					.then(function viewHistory(response) {
						$('#gpt-history').html(response);
					});
				});
			}
		});

		$('.clear-prompt').on('click', function _clearPrompt(e) {
			e.preventDefault();

			$('#gptprompt-gpt_prompt').val('');
		});

		$('.clear-response').on('click', function _clearResponse(e) {
			e.preventDefault();

			$('#gptprompt-gpt_response').val('');
		});

		$('.refine').on('click', function _refine(e) {
			var prompt           = $('#gptprompt-gpt_prompt').val(),
				prompt_trimmed   = prompt.trim(),
				refine_statement = $('#gptprompt-refine').val().trim(),
				responses        = '';

			e.preventDefault();

			if (prompt_trimmed.length === 0) {
				Adzuki.StatusMessage('Error', 'Please provide a full prompt in order to proceed.');
			} else {
				$('#gptprompt-loader-1').css('visibility', 'visible');
				$('#gptprompt-loader-2').removeClass('hidden d-none');
				$('#gptprompt-gpt_response').addClass('hidden d-none');

				prompt_trimmed = prompt_trimmed.replace(/(\r\n|\n|\r)/gm, " ");
				
				Adzuki.Ajax.post('/Ai/processPrompt/', {prompt: refine_statement + ' ' + prompt_trimmed}).then(function success(content) {
					$.each(content.messages, function onEachMessage(i, message) {
						responses += message + "\r\n";
					});

					$('#gptprompt-gpt_response').val(responses);
					$('#gptprompt-loader-1').css('visibility', 'hidden');
					$('#gptprompt-loader-2').addClass('hidden d-none');
					$('#gptprompt-gpt_response').removeClass('hidden d-none');

					$('.refine-prompt-container').removeClass('hidden d-none');
					$('#gptprompt-refine').val('');

					// reload history tab
					Adzuki.Ajax.get('/Ai/gptHistory/')
					.then(function viewHistory(response) {
						$('#gpt-history').html(response);
					});
				});
			}
		});

		$('.clear-refinement').on('click', function _clearRefinement(e) {
			e.preventDefault();
			$('#gptprompt-refine').val('');
		});

		$('#gptprompt-refine').on('keydown', function _refineOnEnter(e) {
			if (e.key === 'Enter' || e.keyCode === 13) {
				e.preventDefault();
				$('.refine').trigger('click');
			}
		});
	};
}(jQuery, window.Adzuki || {}));
